module.exports = __webpack_public_path__ + "static/media/blockain only-03.c79f4412.png";